import { translate } from "@/i18n/I18nProvider";

/** Nome apresentável do utilizador Supabase (Discord OAuth). */
export function userDisplayName(user) {
    if (!user) return "";
    const m = user.user_metadata || {};
    return (
        m.full_name ||
        m.name ||
        m.preferred_username ||
        m.custom_claims?.global_name ||
        user.email ||
        translate("auth.discordAccountFallback")
    );
}
